// Firebase initialisation.
//
// This config is PUBLIC by design — it ships in the browser bundle and is not a
// secret. Security comes from Firestore security rules, which run on Google's
// servers, not from hiding these values (ADR-018). The env vars exist so we can
// point staging and production at different projects, not for secrecy.
//
// Analytics is deliberately NOT initialised. measurementId may be present in the
// config, but calling getAnalytics() sets cookies and therefore triggers consent
// obligations for EU visitors. That is a decision to take deliberately, not a
// side effect of scaffolding.

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const configured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

// M0a ships without accounts (ADR-020 puts the account wall at M1), so a missing
// config must not break the app — it degrades to the anonymous experience.
export const app = configured ? initializeApp(firebaseConfig) : null;
export const auth = app ? getAuth(app) : null;
export const db = app ? getFirestore(app) : null;
export const isFirebaseConfigured = configured;

// Which backend this bundle actually talks to. Read by the shell so a
// non-production build can never be mistaken for the live site.
export const projectId = firebaseConfig.projectId || null;
